var render = function () {
  var _vm$item, _vm$item$question, _vm$item2, _vm$item2$question, _vm$item3, _vm$item3$question, _vm$item4, _vm$item4$question, _vm$item5, _vm$item5$question;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16 line-height-15"
  }, [_vm._v(" " + _vm._s(_vm.index + 1) + ". " + _vm._s((_vm$item = _vm.item) === null || _vm$item === void 0 ? void 0 : (_vm$item$question = _vm$item.question) === null || _vm$item$question === void 0 ? void 0 : _vm$item$question.subject) + " " + _vm._s((_vm$item2 = _vm.item) !== null && _vm$item2 !== void 0 && (_vm$item2$question = _vm$item2.question) !== null && _vm$item2$question !== void 0 && _vm$item2$question.isMultipleSelect ? "(복수선택 가능)" : "") + " ")]), _c('v-divider', {
    staticClass: "primary border-2"
  }), _c('v-sheet', {
    staticClass: "pa-10 px-md-20 py-md-16"
  }, [((_vm$item3 = _vm.item) === null || _vm$item3 === void 0 ? void 0 : (_vm$item3$question = _vm$item3.question) === null || _vm$item3$question === void 0 ? void 0 : _vm$item3$question.type) == _vm.RECRUITMENT_QUESTION_TYPES.SHORT_ANSWER.value ? [_c('v-text-field', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.item.response,
      callback: function callback($$v) {
        _vm.$set(_vm.item, "response", $$v);
      },
      expression: "item.response"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs_input, {
    readonly: _vm.readonly
  }), false))] : ((_vm$item4 = _vm.item) === null || _vm$item4 === void 0 ? void 0 : (_vm$item4$question = _vm$item4.question) === null || _vm$item4$question === void 0 ? void 0 : _vm$item4$question.type) == _vm.RECRUITMENT_QUESTION_TYPES.DESCRIPTIVE.value ? [_c('v-textarea', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.item.response,
      callback: function callback($$v) {
        _vm.$set(_vm.item, "response", $$v);
      },
      expression: "item.response"
    }
  }, 'v-textarea', Object.assign({}, _vm.attrs_input, {
    readonly: _vm.readonly
  }), false))] : ((_vm$item5 = _vm.item) === null || _vm$item5 === void 0 ? void 0 : (_vm$item5$question = _vm$item5.question) === null || _vm$item5$question === void 0 ? void 0 : _vm$item5$question.type) == _vm.RECRUITMENT_QUESTION_TYPES.MULTIPLE_CHOICE.value ? [_vm.item.question.isMultipleSelect ? _c('v-row', {
    staticClass: "ma-0",
    attrs: {
      "no-gutters": ""
    }
  }, _vm._l(_vm.item.question.choices, function (choice) {
    return _c('v-col', {
      key: choice,
      staticClass: "mr-20",
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-checkbox', _vm._b({
      attrs: {
        "multiple": "",
        "value": choice,
        "label": choice,
        "hide-details": ""
      },
      on: {
        "change": _vm.emit
      },
      model: {
        value: _vm.item.response,
        callback: function callback($$v) {
          _vm.$set(_vm.item, "response", $$v);
        },
        expression: "item.response"
      }
    }, 'v-checkbox', {
      readonly: _vm.readonly
    }, false))], 1);
  }), 1) : _c('v-radio-group', {
    attrs: {
      "row": "",
      "hide-details": ""
    },
    model: {
      value: _vm.item.response,
      callback: function callback($$v) {
        _vm.$set(_vm.item, "response", $$v);
      },
      expression: "item.response"
    }
  }, _vm._l(_vm.item.question.choices, function (choice) {
    return _c('v-radio', _vm._b({
      key: choice,
      attrs: {
        "label": choice,
        "value": choice
      },
      on: {
        "change": _vm.emit
      }
    }, 'v-radio', {
      readonly: _vm.readonly
    }, false));
  }), 1)] : _vm._e()], 2), _c('v-divider')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }